'use strict';

var GridToolbarConfigurationMarketClassFareDirective = function GridToolbarConfigurationMarketClassFareDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/grid-toolbar-configuration-market-class-fare.html'),
    controller: 'GridToolbarConfigurationMarketClassFareController',
    link: function link(scope) {
      scope.$on('grid:rowSelectionChanged', function (event, selectedRows) {
        scope.onRowSelection(selectedRows);
      });
    }
  };
};
GridToolbarConfigurationMarketClassFareDirective.$inject = [];
module.exports = GridToolbarConfigurationMarketClassFareDirective;